/* ORYX App 2.0
 *
 * Created by ORYX Movement Solutions © 2022
 * ==================================================================
 *
 * Homepage.
 */

import { IonContent, IonPage } from '@ionic/react';

import { PageHeader } from '@/components/PageHeader/PageHeader';
import { PageTopBar } from '@/components/PageTopBar/PageTopBar';
import { SelectDataFileActionSection, SelectDataFileInformationSection } from '@/components/SelectDataFileSections';

import { mergeClassNames } from '@/utils';

import Step1BackgroundImage from '@/assets/illustrations/upload-data-1.png';
import Step2BackgroundImage from '@/assets/illustrations/upload-data-2.png';

import styles from './OpenFilePageTest.module.css';

export const OpenFilePage = () => {
  return (
    <>
      <IonPage id='main'>
        <PageHeader
          style={{ height: '75px' }}
          topSlot={
            <PageTopBar backTarget={'/sensortesting'} description={'New Session'} title={'Krista'} variant='simple' />
          }></PageHeader>
        <div className={styles.background}>
          <IonContent className={mergeClassNames('ion-no-padding', styles.content)} color='light' id='main'>
            <div className={styles.container}>
              <SelectDataFileActionSection
                buttonOnclick={() => {
                  console.log('not implemented');
                }}
                buttonText={'Upload file'}
                description={
                  'To connect with the sensor hub, tap *“Upload file”* and select the data file on your device.'
                }
                title={'Upload data file'}
              />

              {/* Right Panel */}
              <SelectDataFileInformationSection
                steps={[
                  {
                    index: 1,
                    image: Step1BackgroundImage,
                    title: 'Open the Sensor Hub location',
                    description: 'In your files select *QSENSEHUB* under the *locations* section on the left panel.',
                  },
                  {
                    index: 2,
                    image: Step2BackgroundImage,
                    title: 'Select the data file',
                    description:
                      'The right panel will show the files within, select *data* to allow connection with the hub.',
                  },
                ]}
              />
            </div>
          </IonContent>
        </div>
      </IonPage>
    </>
  );
};
